//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import area from'./address.js'
export default {
    data() {
        return {
            provincial:'',
            provincialList:[],
            city:'',
            cityList:[],
            district:'',
            districtList:[],
            purchasingStatus:0,
            purchasingStatusList:[
                {value:0,label:'未采购'},
                {value:1,label:'电商用户'},
                {value:2,label:'云库存用户'},
            ],
            areaData:area,
            shopAddress:'',
            linkman:'',
            shopPhone:'',
            res:{},
            shopName:''
        }
    },
    created(){
        this.info()
    },
    methods: {
        info(){
            this.res = {provincial: '',provincialId: '',city: '',cityId: '',district: '',districtId: ''}
            this.$axios.get('/mtea/stock/shopInfo/get', {params:{sysShopId:this.$route.query.shopId}}).then(msg => {
                console.log(msg)
                this.res.provincial = msg.shopProvince
                this.res.city = msg.shopCity
                this.res.district = msg.shopArea
                console.log(this.res)
                for(let i = 0;i<this.areaData.length;i++){
                    if(this.areaData[i].TopID === 0){
                        this.provincialList.push(this.areaData[i]) 
                        if(this.areaData[i].AddName === this.res.provincial)
                        this.res.provincialId = this.areaData[i].ID
                    }
                    if(this.res.provincialId !== -1 && this.areaData[i].TopID === this.res.provincialId){
                        this.cityList.push(this.areaData[i])
                        if(this.areaData[i].AddName === this.res.city)
                        this.res.cityId = this.areaData[i].ID
                    }
                    if(this.res.cityId !== -1 && this.areaData[i].TopID === this.res.cityId)
                        this.districtList.push(this.areaData[i])
                        if(this.areaData[i].AddName === this.res.district)
                        this.res.districtId = this.areaData[i].ID
                }
                console.log(this.res)
                this.provincial = this.res.provincialId
                this.city = this.res.cityId
                this.district = this.res.districtId
                this.shopAddress= msg.shopAddress
                this.linkman= msg.linkman
                this.shopPhone= msg.shopPhone
                this.purchasingStatus = msg.purchaseStatus
                this.shopName = msg.shopName
            })

        },
        changeProvincial(ID){
            console.log(ID)
            this.city = ''
            this.cityList = []
            this.district = ''
            this.districtList = []
            for(let i = 0;i<this.areaData.length;i++){
                if(this.areaData[i].TopID === ID)
                this.cityList.push(this.areaData[i])
                if(this.areaData[i].TopID > ID) break
            } 
        },
        changeCity(ID){
            this.district = ''
            this.districtList = []
            for(let i = 0;i<this.areaData.length;i++){
                if(this.areaData[i].TopID === ID)
                this.districtList.push(this.areaData[i])
                if(this.areaData[i].TopID > ID) return
            } 
        },
        changeDistrict(ID){
            console.log(ID)
            this.districtList.forEach(e=>{
                if(e.ID === ID)
                this.res.district = e.AddName
            })
        },
        clickFun(){
            console.log(this.res)
            let data = {
                linkman:this.linkman,
                purchaseStatus:this.purchasingStatus,
                shopAddress:this.shopAddress,
                shopArea:this.res.district,
                shopCity:this.res.city,
                shopProvince:this.res.provincial,
                shopId:this.$route.query.shopId,
                shopPhone:this.shopPhone,
            }
            console.log(data)
            this.$axios.post('/mtea/stock/shopInfo/modify',data).then(()=>{
                this.$message({
                    message: '保存成功',
                    type: 'success'
                });
                this.$router.go(-1)
            })

        }
    },
}
